import React from 'react';
import { Drawer } from 'antd';
import useStatistics from '../../hooks/data/useStatistics';
import StatisticsProvider from '../../views/dashboard/StatisticsProvider';
import LineChartGrid from '../../components/stats/LineChartGrid';
import useScreenType from '../../hooks/context/useScreenType';

export default function MetricDetailsModal({
  toggle,
  mainMetrics = [],
  reservationMetrics = [],
  marketingMetrics = [],
  googleMetrics = [],
  storefrontMetrics = [],
  excludedHistoryMetrics = [],
}) {
  const { dateRangeFilter } = useStatistics();
  const { isDesktop } = useScreenType();

  return (
    <StatisticsProvider
      dateRangeFilter={dateRangeFilter}
      mainMetrics={mainMetrics}
      reservationMetrics={reservationMetrics}
      marketingMetrics={marketingMetrics}
      googleMetrics={googleMetrics}
      storefrontMetrics={storefrontMetrics}
      excludedHistoryMetrics={excludedHistoryMetrics}
      withInterval
    >
      <Drawer open onClose={toggle} footer={null} size={window.innerWidth * (isDesktop ? 0.4 : 1)} placement="right">
        <LineChartGrid className="grid grid-cols-1 gap-4" />
      </Drawer>
    </StatisticsProvider>
  );
}
